import * as types from '../mutation-types'

const {title, options} = window.config

// state
export const state = {
    visible: false,
    title: '',
    options: []
}

// getters
export const getters = {
    visible: state => state.visible,
    title: state => state.title,
    options: state => state.options
}

// mutations
export const mutations = {
    [types.SHOW_CHILDNAV](state, {title, options}) {
        state.visible = true;
        state.title = title;
        state.options = options
    },
    [types.HIDE_CHILDNAV](state) {
        state.visible = false;
    },
}

// actions
export const actions = {
    show({commit}, {title, options}) {
        commit(types.SHOW_CHILDNAV, {title, options})
    },
    hide({commit}) {
        commit(types.HIDE_CHILDNAV)
    },
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/childnav.js